import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Margin } from 'shared/components'

import { EventDetailsPanel } from './components/eventDetailsPanel'
import { TournamentDetailsPanel } from './components/tournamentDetailsPanel'
import { TournamentHeader } from './components/tournamentHeader'

const EventViewComponent = ({ eventId }) => {
  const browserWindow = globalThis.window
  // Initialize mobile detection immediately to prevent desktop component from loading first
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(() => {
    // Check screen size on initial render
    return !!browserWindow && browserWindow.innerWidth <= 1024
  })
  const [activeTab, setActiveTab] = useState('games')

  useEffect(() => {
    if (!browserWindow) {
      return undefined
    }

    const checkScreenSize = () => {
      // Show tournament view for mobile and tablet (up to 1024px)
      setIsMobileOrTablet(browserWindow.innerWidth <= 1024)
    }

    // Double-check on mount in case the initial detection was wrong
    checkScreenSize()
    browserWindow.addEventListener('resize', checkScreenSize)

    return () => browserWindow.removeEventListener('resize', checkScreenSize)
  }, [])

  const handleTabChange = (tab) => {
    setActiveTab(tab)
  }

  if (isMobileOrTablet) {
    return (
      <>
        <TournamentHeader
          eventId={eventId}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
        <TournamentDetailsPanel
          eventId={eventId}
          activeTab={activeTab}
        />
      </>
    )
  }

  // Show original event details for laptop/desktop
  return (
    <Margin bottom={2}>
      <EventDetailsPanel eventId={eventId} />
    </Margin>
  )
}

EventViewComponent.propTypes = {
  eventId: PropTypes.number,
}

export default EventViewComponent
